import { get, map, chain, pick } from "lodash"
import { createSelector } from "reselect"
import { percentageFormatter } from "helpers/formatters/numbers"
import { getScanResult, getCoverage } from "."

export const getAttributes = createSelector(
  [getScanResult],
  (result) => {
    return chain(result)
      .get("scan.summary.averageAttributeCoverage")
      .keys()
      .value()
  },
)

export const getNoAttributeSecurities = createSelector(
  [getScanResult],
  (scanResult) => chain(scanResult)
    .get("scan.noAttributeSecurities")
    .reduce((acc, securities, attribute) => ([
      ...acc,
      ...map(securities, (security) => ({
        ...security,
        attributeCategory: attribute,
        // need a unique id for the table to work properly
        id: `${security.ticker}-${security.sedol}-${security.modelProviderId}-${attribute}-${security.lotId}`,
        identifier: security.ticker || security.sedol })),
    ]), [])
    .value(),
)

export const getAttributeRows = createSelector(
  [getCoverage, getAttributes],
  (coverage, attributes) => {
    const rows = chain(coverage)
      .get("dates")
      .map((date) => map(attributes, attribute => ({
        // need a unique id for the table to work properly
        id: `${attribute}-${date.date}`,
        attributeCategory: attribute,
        ...pick(date, ["date", "formattedDate"]),
        percentWithAttributes: percentageFormatter(get(date, ["attributes", attribute, "percentWithAttributes"]) / 100),
        percentNoAttributeEquities: percentageFormatter(get(date, ["attributes", attribute, "percentNoAttributeEquities"]) / 100),
        noAttributeSecurities: get(date, ["attributes", attribute, "noAttributeSecurities"]),
      })))
      .flatten()
      .value()
    return rows
  },
)
